module.exports = __webpack_public_path__ + "img/扶梯5.b2eea8af.png";